import { render, staticRenderFns } from "./applyRelease.vue?vue&type=template&id=4a6bc2e0&"
import script from "./applyRelease.vue?vue&type=script&lang=js&"
export * from "./applyRelease.vue?vue&type=script&lang=js&"
import style0 from "./applyRelease.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports